import { DetailArrayValue, DetailLink, DetailValue } from 'components/DetailsView';
import { SectionContainer } from 'components/DetailsView/Section';

import { SupplierOrderingTermsSummary } from '../../shared/SupplierOrderingTermsSummary';
import { SupplyOrderDetails } from '../supplyOrderFormValues';

const WEEKDAYS = [
    { key: 'monday', label: 'Lundi' },
    { key: 'tuesday', label: 'Mardi' },
    { key: 'wednesday', label: 'Mercredi' },
    { key: 'thursday', label: 'Jeudi' },
    { key: 'friday', label: 'Vendredi' },
    { key: 'saturday', label: 'Samedi' },
    { key: 'sunday', label: 'Dimanche' },
] as const;

/** Les conditions du fournisseur : franco, minimum de commande, délais de livraison par jour. */
export const SupplierSection = ({ supplyOrder }: { supplyOrder: SupplyOrderDetails }) => {
    const { supplier } = supplyOrder;

    return (
        <SectionContainer title="Fournisseur et conditions de commande">
            <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-x-8 gap-y-4">
                <div className="flex flex-col gap-4">
                    <DetailLink label="Fiche fournisseur" path="supplier" value={supplier._id} name={supplier.name} />
                    <DetailValue label="Code client" value={supplier.clientCode} />
                    <DetailValue label="Mode de commande" value={supplier.orderMode} />
                    <DetailValue
                        label="Indice de risque"
                        sublabel="De 1 (fiable) à 3 (retards systématiques)"
                        value={supplier.frequency}
                    />
                    <DetailArrayValue label="Emails de commande" values={supplier.orderEmails} />
                </div>

                <div className="flex flex-col gap-4">
                    <SupplierOrderingTermsSummary orderingTerms={supplier.orderingTerms} />
                </div>

                <div className="flex flex-col gap-1">
                    <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
                        Délais jusqu'à réception
                    </span>
                    <ul className="flex flex-col gap-0.5 text-sm">
                        {WEEKDAYS.map(({ key, label }) => {
                            const { orderBefore, daysToDeliver, canBeOrdered } = supplier.orderingTimes[key];
                            return (
                                <li key={key} className={canBeOrdered ? undefined : 'text-muted-foreground'}>
                                    {canBeOrdered
                                        ? `${label} avant ${orderBefore} → réception ${daysToDeliver} jour(s) plus tard`
                                        : `${label} — pas de commande possible`}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </SectionContainer>
    );
};
